import { Form, message, Space, Tabs, TabsProps } from "antd";
import { ClientDTO } from "../../openapi/requests";
import { useClientServicePostBackendv2Client, useClientServicePutBackendv2Client } from "../../backendapi/queries";
import OutputFormatList from "../outputFormats/OutputFormatList";
import Layout, { Header } from "antd/es/layout/layout";
import { useContext } from "react";
import { ConfigContext } from "../../contexts/ConfigContext";
import Title from "antd/es/typography/Title";
import EditClient from "./EditClient";
import ClientDetailEdit from "./ClientDetailEdit";
import ClientImportExport from "./ClientImportExport";

const ClientDetail: React.FC = () => {
  const { currentClient } = useContext(ConfigContext);

 // const [form] = Form.useForm<ClientDTO>();
 // const [messageApi, contextHolder] = message.useMessage();

  //  const { mutate: updateClient, isSuccess: clientCreated, isPending, isError, error } = useClientsServicePutBackendClient();
  //  const { mutate: createClient, isSuccess: clientUpdated, isPending, isError, error } = useClientsServicePostBackendClient();

  const onClose = () => {};

  const items: TabsProps["items"] = [
    {
      key: "detail",
      label: "Detail",
      children: <ClientDetailEdit />,
    },
    {
      key: "outputformat",
      label: "Output Formats",
      children: <OutputFormatList />,
    },
    {
      key: "importexport",
      label: "Import/Export",
      children: <ClientImportExport client={currentClient} />
    }
  ];

  const onChange = () => {};

  return (
    <>
      <Space>
        <Title> {currentClient.name}</Title>
      </Space>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </>
  );
};

export default ClientDetail;
